__turbopack_context__.v({
  "close-container": "Popover-module-scss-module___PMwua__close-container",
  "container": "Popover-module-scss-module___PMwua__container",
});
